import { render, staticRenderFns } from "./EvaluacionDisciplinaAdministrativaCardComponent.vue?vue&type=template&id=badabb3c"
import script from "./EvaluacionDisciplinaAdministrativaCardComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionDisciplinaAdministrativaCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports